export function msToS(ms, fractionDigits) {
    if (fractionDigits === void 0) { fractionDigits = 4; }
    return (ms / 1000).toFixed(fractionDigits) + 's';
}
export function formatNumber(num, fractionDigits) {
    if (fractionDigits === void 0) { fractionDigits = 1; }
    if (num === undefined)
        return '';
    if (num >= 1000000000000) {
        return (num / 1000000000000).toFixed(fractionDigits) + 'T';
    }
    else if (num >= 1000000000) {
        return (num / 1000000000).toFixed(fractionDigits) + 'B';
    }
    else if (num >= 1000000) {
        return (num / 1000000).toFixed(fractionDigits) + 'M';
    }
    else if (num >= 1000) {
        return (num / 1000).toFixed(fractionDigits) + 'K';
    }
    else {
        return num.toString();
    }
}
export function formatTime(timeMs, withZeroPadding) {
    if (withZeroPadding === void 0) { withZeroPadding = true; }
    var timeSec = Math.max(Math.floor(timeMs / 1000), 0);
    var timeHours = Math.floor(timeSec / 3600);
    timeSec %= 3600;
    var timeMin = Math.floor(timeSec / 60);
    timeSec %= 60;
    var secPrefix = '';
    var result = '';
    if (timeHours > 0) {
        result += "".concat(timeHours, "h");
    }
    if (timeMin > 0 || timeHours > 0) {
        result += "".concat(timeMin, "m");
    }
    secPrefix = timeSec < 10 && withZeroPadding ? '0' : '';
    result += "".concat(secPrefix).concat(timeSec, "s");
    return result;
}
